import { cn } from "@/lib/utils";
import * as React from "react";

const Input = React.memo(
  React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
    ({ className, type, inputMode, ...props }, ref) => {
      // Auto-set inputMode based on type for better mobile keyboard experience
      const getInputMode = () => {
        if (inputMode) return inputMode;
        switch (type) {
          case "number":
          case "tel":
            return "numeric";
          case "email":
            return "email";
          case "url":
            return "url";
          case "search":
            return "search";
          default:
            return undefined;
        }
      };

      return (
        <input
          type={type}
          inputMode={getInputMode()}
          autoComplete="off"
          className={cn(
            // Square Style Input - Sharp corners, border focused
            "h-11 min-h-[44px] w-full rounded-none border border-neutral-300 bg-white px-4 py-2 text-base text-neutral-900 transition-all duration-150",
            "placeholder:text-neutral-400",
            "focus-visible:border-neutral-900 focus-visible:ring-1 focus-visible:ring-neutral-900 focus-visible:outline-none",
            "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:opacity-55",
            "aria-readonly:cursor-not-allowed aria-readonly:bg-neutral-50 aria-readonly:opacity-70",
            "touch-manipulation",
            type === "date" && "min-h-[44px] w-auto",
            type === "search" &&
              "[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none [&::-webkit-search-results-button]:appearance-none [&::-webkit-search-results-decoration]:appearance-none",
            type === "file" &&
              "p-0 pe-3 text-neutral-400 italic file:me-3 file:h-full file:border-0 file:border-e file:border-solid file:border-neutral-300 file:bg-transparent file:px-3 file:text-sm file:font-medium file:text-neutral-900 file:not-italic",
            className,
          )}
          ref={ref}
          {...props}
        />
      );
    },
  ),
);
Input.displayName = "Input";

export { Input };
